import React from "react";

function IsActive({ isActive }) {
    if (isActive === null || isActive === undefined) {
        return <p className="text-slate-400">----</p>;
    }

    return (
        <p
            className={`font-bold ${isActive ? "text-green-600" : "text-red-500"
                }`}
        >
            {isActive ? "فعال ✅" : "غیرفعال ❌"}
        </p>
    );
}

export default IsActive;
